import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
var SharePreprint = function SharePreprint(_ref) {
  var campaignName = _ref.campaignName;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "share-preprint"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "preprint-link-heading"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "preprint-link-text"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": t('preprint-link-cta'),
    className: "btn btn-primary btn-small trackable-link",
    href: "https://www.researchsquare.com/welcome/aje?utm_source=aje&utm_medium=referral&utm_campaign=".concat(campaignName)
  }, /*#__PURE__*/React.createElement(T, {
    source: "preprint-link-cta"
  })))));
};
export default SharePreprint;